module.exports = __webpack_public_path__ + "static/media/3_MC.97fd2834.jpg";